import headerMenuDropdown from './header-menu-dropdown.component';

export default angular
  .module('fizyweb.paycell.header-menu-dropdown', [])
  .component('headerMenuDropdown', headerMenuDropdown).name;



// WEBPACK FOOTER //
// src/app/components/header-menu-dropdown/header-menu-dropdown.module.ts